import { render, staticRenderFns } from "./AddPurchaseModal.vue?vue&type=template&id=351c07af&"
import script from "./AddPurchaseModal.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports